import { createElement } from "react";
import React from "react";
import * as react from "react";
import { ContextProvider, ContextMsg, useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { User, toastServerError, Workplace } from "./ApiClient.jsx";
import { errorToast } from "./Toasts.jsx";
import { Spinner, webLightTheme, FluentProvider, Divider, DialogActions, Text as Text$, Option, Dropdown, Field, Body1Strong, Caption1, tokens, DialogContent, Button, DialogTitle, DialogBody, DialogSurface, Dialog } from "@fluentui/react-components";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { take, length, empty, iterate, tryHead, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { SendRegular, HourglassHalfRegular, SignOutRegular } from "@fluentui/react-icons";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toArray, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { map as map_1, tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { UpdatedUser } from "./Shared/SharedModels.jsx";
import { CurrentPage, pageFromUrl } from "./Routes.jsx";
import { RouterModule_router, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { injectCss } from "./Helpers.jsx";
import { Sidebar } from "./Sidebar.jsx";
import { Headerbar } from "./Headerbar.jsx";
import { createRoot } from "react-dom/client";

function ApproveUserDialog(user) {
    let elems_8, el_37, elems_7, el_35, elems_6, elemsToUse;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState([]);
    const workplaces = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const selectedWorkplace = patternInput_2[0];
    useEffectOnce(() => {
        let pr_3;
        const pr_2 = startAsPromise(Workplace.GetEnabledWorkplaces());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Kunne ikke hente arbeidsplasser", "Noe gikk galt", undefined);
            }
            else {
                patternInput_1[1](res_1.fields[0]);
            }
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
    });
    const el_39 = Dialog;
    return createElement(el_39, createObj(ofArray([["open", !user.Enabled], (elems_8 = [(el_37 = DialogSurface, createElement(el_37, createObj(singleton_1((elems_7 = [(el_35 = DialogBody, createElement(el_35, createObj(singleton_1((elems_6 = toList(delay(() => {
        let el_4;
        return append(singleton((el_4 = DialogTitle, createElement(el_4, createObj(toList(delay(() => {
            let el_2, el;
            return append(singleton(["action", (el_2 = Button, createElement(el_2, {
                size: "small",
                as: "a",
                children: "Logg ut",
                iconPosition: "after",
                icon: (el = SignOutRegular, createElement(el, {})),
                href: "/api/logout",
            }))]), delay(() => ((user.Workplace == null) ? singleton(["children", "Arbeidsplass kreves"]) : singleton(["children", "Bruker må godkjennes"]))));
        })))))), delay(() => {
            let el_27, elems_4;
            return append(singleton((el_27 = DialogContent, createElement(el_27, createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 5 + "px ",
                alignItems: "center",
            }], (elems_4 = toList(delay(() => {
                let el_6;
                return append(singleton((el_6 = HourglassHalfRegular, createElement(el_6, {
                    style: {
                        fontSize: 96 + "px",
                    },
                    primaryFill: tokens.colorBrandForeground2,
                }))), delay(() => {
                    let elems_3, el_21, el_23, el_25, el_8, value_34;
                    const matchValue = user.Workplace;
                    if (matchValue != null) {
                        const wp_2 = matchValue;
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }], (elems_3 = [(el_21 = Caption1, createElement(el_21, {
                            children: "Din bruker må godkjennes av en administrator før du kan gå videre i portalen",
                        })), (el_23 = Caption1, createElement(el_23, {
                            style: {
                                marginTop: 15,
                            },
                            children: "Arbeidsplass",
                        })), (el_25 = Body1Strong, createElement(el_25, {
                            children: `${wp_2.Name}`,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                    }
                    else {
                        return append(singleton((el_8 = Caption1, createElement(el_8, createObj(ofArray([["align", "center"], (value_34 = "Din bruker krever en arbeidsplass for å få tilgang til portalen. Velg din arbeidsplass og send til godkjenning av administrator", ["children", value_34])]))))), delay(() => {
                            let el_19, matchValue_1, el_16, elems_1;
                            return singleton((el_19 = Field, createElement(el_19, {
                                label: "Arbeidsplass",
                                children: (matchValue_1 = tryHead([(el_16 = Dropdown, createElement(el_16, createObj(ofArray([["value", defaultArg(map((_arg_1) => _arg_1.Name, selectedWorkplace), "")], ["onOptionSelect", (_arg_2, value_1_11) => {
                                    iterate((selected) => {
                                        patternInput_2[1](tryFind((wp) => (wp.Name === selected), workplaces));
                                    }, toArray(value_1_11.optionValue));
                                }], (elems_1 = toList(delay(() => map_1((wp_1) => {
                                    let elems, el_10, el_12;
                                    const el_14 = Option;
                                    return createElement(el_14, createObj(ofArray([["value", wp_1.Name], (elems = [(el_10 = Text$, createElement(el_10, {
                                        children: wp_1.Name,
                                    })), (el_12 = Caption1, createElement(el_12, {
                                        children: wp_1.Region.Name,
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
                                }, workplaces))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
                            })));
                        }));
                    }
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))), delay(() => {
                let el_33, elems_5, el_31, el_29;
                return (!user.Enabled && (user.Workplace == null)) ? singleton((el_33 = DialogActions, createElement(el_33, createObj(ofArray([["position", "end"], (elems_5 = [(el_31 = Button, createElement(el_31, {
                    disabled: selectedWorkplace == null,
                    icon: (el_29 = SendRegular, createElement(el_29, {})),
                    iconPosition: "after",
                    appearance: "primary",
                    children: "Send",
                    onClick: (_arg_3) => {
                        iterate((wp_3) => {
                            let pr_1;
                            const pr = startAsPromise(User.UpdateUser(user.Id, new UpdatedUser(user.FirstName, user.LastName, user.Enabled, user.IsAdmin, wp_3.Id)));
                            pr_1 = (pr.then((res) => {
                                if (res.tag === 1) {
                                    switch (res.fields[0].tag) {
                                        case 1: {
                                            errorToast(setCtx, `updateUser${user.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                                            break;
                                        }
                                        case 2: {
                                            errorToast(setCtx, `updateUser${user.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                                            break;
                                        }
                                        default:
                                            errorToast(setCtx, `updateUser${user.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
                                    }
                                }
                                else {
                                    setCtx(new ContextMsg(2, [res.fields[0]]));
                                }
                                return res;
                            }));
                            void (pr_1.catch((ex) => {
                                toastServerError(setCtx, ex);
                            }));
                        }, toArray(selectedWorkplace));
                    },
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : empty();
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])))))], (elemsToUse = ((length(elems_8) <= 2) ? elems_8 : take(2, elems_8)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

const cssOverride = `
      .fui-Caption2.fui-Text {
            color: ${tokens.colorNeutralForeground3};
        }
      .fui-Caption1.fui-Text {
            color: ${tokens.colorNeutralForeground3};
        }
      .fui-NavItem {
          background-color: ${tokens.colorNeutralBackground1};
      }
          background-color: ${tokens.colorSubtleBackgroundInvertedHover};
      .fui-NavItem:hover {
      }
      .fui-NavCategoryItem {
          background-color: ${tokens.colorNeutralBackground1};
      }
          background-color: ${tokens.colorSubtleBackgroundInvertedHover};
      .fui-NavCategoryItem:hover {
      }
      .fui-NavSubItem {
          background-color: ${tokens.colorNeutralBackground1};
      }
          background-color: ${tokens.colorSubtleBackgroundInvertedHover};
      .fui-NavSubItem:hover {
      }
    `;

function Application() {
    let elements, elems_1, el, elems;
    const ctx = useCtx()[0];
    let patternInput_1;
    const initial = pageFromUrl(RouterModule_urlSegments(window.location.hash, 1));
    patternInput_1 = reactApi.useState(initial);
    injectCss(cssOverride);
    return RouterModule_router(createObj(ofArray([["hashMode", 1], ["onUrlChanged", (url_1) => {
        patternInput_1[1](pageFromUrl(url_1));
    }], (elements = singleton_1(createElement("div", createObj(ofArray([["style", {
        width: 100 + "vw",
        height: 100 + "vh",
        display: "flex",
        flexDirection: "row",
    }], (elems_1 = [createElement(Sidebar, null), (el = Divider, createElement(el, {
        appearance: "subtle",
        vertical: true,
    })), createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
    }], (elems = toList(delay(() => append(singleton(createElement(Headerbar, null)), delay(() => (!ctx.User.Enabled ? singleton(createElement(ApproveUserDialog, ctx.User)) : singleton(createElement(CurrentPage, {
        currentPage: patternInput_1[0],
    }))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
}

function Root() {
    let value, elems_1, elems, el_2, el;
    const patternInput = reactApi.useState(undefined);
    const session = patternInput[0];
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(User.GetSession());
        pr_1 = (pr.then((r) => {
            if (r.tag === 1) {
                window.location.href = "/api/login";
            }
            else {
                patternInput[1](r.fields[0]);
            }
            return r;
        }));
        void (pr_1.catch((_ex) => {
            window.location.href = "/api/login";
        }));
    });
    if (session != null) {
        const s = session;
        return createElement(ContextProvider, {
            session: s,
            children: singleton_1(createElement(Application, null)),
        });
    }
    else {
        const el_4 = FluentProvider;
        return createElement(el_4, createObj(ofArray([(value = webLightTheme, ["theme", value]), (elems_1 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            height: 100 + "vh",
            width: 100 + "vw",
            flexDirection: "column",
            gap: 5 + "px ",
            justifyContent: "center",
            alignItems: "center",
        }], (elems = [(el_2 = Spinner, createElement(el_2, {
            size: "large",
            labelPosition: "below",
            label: (el = Text$, createElement(el, {
                children: "Logger inn...",
            })),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
    }
}

const root = createRoot(document.getElementById("root"));

root.render((() => {
    const children = singleton_1(createElement(Root, null));
    return reactApi.createElement(reactApi.StrictMode, undefined, ...children);
})());

//# sourceMappingURL=App.jsx.map
